import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import Modal from '../../../components/Modal';
import { BodyLarge, ParagraphLargeText } from '../../../components/Texts';
import SocialShareOptions from '../../../components/SocialShareOptions';

const ShareGift = ({ onClose, claimUrl }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Modal onClose={onClose} width='430px'>
      <ParagraphLargeText style={{ color: theme.text.regular }}>
        {t('shareGift.title')}
      </ParagraphLargeText>
      <BodyLarge style={{ margin: '10px 0px 10px 0px', textAlign: 'center' }}>
        {t('shareGift.description')}
      </BodyLarge>
      <SocialShareOptions claimUrl={claimUrl} />
    </Modal>
  );
};

export default ShareGift;
